import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { BuildingIcon, OfficeIcon, LeftArrowIcon, RightChevronIcon } from "../../../shared/icons/Icons";
import "./ProjectTypeSelector.scss";

const ProjectTypeSelector = (props) => {
    const [selectedType, setSelectedType] = useState(null);
    const history = useHistory();

    const projectTypes = [
        {
            id: "RESIDENTIAL",
            label: "Residential",
            description: "Houses, villas, and residential buildings",
            icon: BuildingIcon,
            color: "#7e22ce"
        },
        {
            id: "COMMERCIAL",
            label: "Commercial",
            description: "Offices, shops, and commercial complexes",
            icon: OfficeIcon,
            color: "#0032CD"
        }
    ];

    const handleNext = () => {
        if (selectedType) {
            history.push({
                pathname: "/projects/new",
                state: { projectType: selectedType }
            });
        }
    };

    const handleBack = () => {
        props.history.push("/projects");
    };

    return (
        <div className="project-type-selector-container animate-fade-in">
            <div className="project-type-content">
                <div className="project-type-header">
                    <h3 className="content-label">Select Project Type</h3>
                    <p className="content-sub-label">Choose the type of project you want to create</p>
                </div>

                <div className="project-type-cards">
                    {projectTypes.map((type) => {
                        const IconComponent = type.icon;
                        return (
                            <div
                                key={type.id}
                                className={`project-type-card ${selectedType === type.id ? "selected" : ""}`}
                                onClick={() => setSelectedType(type.id)}
                            >
                                <div className="project-type-card-icon" style={{ backgroundColor: type.color }}>
                                    <IconComponent color="#FFF" size={40} />
                                </div>
                                <div className="project-type-card-content">
                                    <h4 className="project-type-card-title">{type.label}</h4>
                                    <p className="project-type-card-description">{type.description}</p>
                                </div>
                                <div className="project-type-card-check">
                                    {selectedType === type.id && (
                                        <div className="check-icon">✓</div>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>

                <div className="project-type-actions">
                    <button
                        className="btn btn-secondary rounded-pill d-flex align-items-center justify-content-center gap-2"
                        onClick={handleBack}
                    >
                        <LeftArrowIcon size="14" />
                        Back
                    </button>
                    <button
                        className="btn btn-solid-blue fw-bold d-flex align-items-center justify-content-center gap-2"
                        onClick={handleNext}
                        disabled={!selectedType}
                    >
                        Next
                        <RightChevronIcon size="14" />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ProjectTypeSelector;
